import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { WidgetComponent } from "../../../dashboards/components/widget-component/widget-component";
import { Store } from '@ngrx/store';
import { ApplicationState } from "../../../store/application-store";
import { DashboardItem } from "../../../dashboards/models/dashboard-item";
import { ConfirmationService } from 'primeng/api';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mojo-designer-widget',
  templateUrl: './designer-widget.component.html'
})
export class DesignerWidgetComponent extends WidgetComponent {

  @Output() onDashboardDesignerDelete = new EventEmitter<DashboardItem>();

  constructor(protected store: Store<ApplicationState>,
    protected confirmationService: ConfirmationService) {
    super(store, confirmationService);
  }


  bubbleDashboardDesignerDelete(dashboardItem) {
    this.onDashboardDesignerDelete.emit(dashboardItem);
  }

  

}
